<template>
<popup class="timezone-popup" title="Update your timezone" @close="close">
	<template v-slot:content>
		<div class="layout-column">
			<p>
				Select your timezone, this will be used in all charts and analytics on your dashboard.
			</p>
			<v-select v-model="user.time_zone" label="name"
			          :reduce="x => x.id"
			          append-to-body :options="timezones" :clearable="false" searchable>
			</v-select>
			<p class="info-message">
				It can take a while for your timezone change to fully propagate.
			</p>
		</div>
	</template>
	<template v-slot:actions>
		<v-button label="Update timezone" :loading="saving" @click="save" :disabled="!user.time_zone" />
		<v-button label="Cancel" border @click="close" />
	</template>
</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import {timezones} from "@/helpers/timezones";
import API from "@/api"

export default {
	name: "timezone-popup", components: {VButton, Popup},
	mixins:[API],
	data(){
		return {
			saving: false,
			timezones: timezones,
		}
	},
	computed:{
		user(){
			return this.$store.state.userInfo;
		}
	},
	methods:{
		async save(){
			try {
				this.saving = true;

				let r = await this.api.users.updateTimezone(this.user.time_zone, false);
				if (!r || r.time_zone !== this.user.time_zone) {
					this.$warn("Something went wrong! try again later.", "Something went wrong! try again later.");
				} else {
					this.$info("","Your timezone was updated successfully.")
					this.$emit("done", r.time_zone);
					window.location.reload();
				}
			} catch (e) {
				this.$warn(e)
			} finally {
				this.saving = false;
			}
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>

<style lang="scss" scoped>
.timezone-popup{

}
</style>
